// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"02322ebd","372":"043a0563","377":"ed994dff","443":"49217940","451":"b071ce4b","453":"361fbfda","971":"ecac872e"}[chunkId] + ".chunk.js";
};